import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import i18n from './i18n'
import './assets/css/main.css'


Vue.config.productionTip = false
moment.locale(i18n.locale)
Vue.prototype.moment = moment


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')